<template>
    <div class="user-2fa-section">
        <h5 class="user-2fa-section__title">Exigir Autenticação em dois fatores (2AF)</h5>
        <div class="user-2fa-section__control">
            <b-form-checkbox
                switch
                :id="inputId"
                :checked="value"
                @input="$emit('input', $event)"
            />
            <span
                class="user-2fa-section__status"
                :class="{ 'user-2fa-section__status--active': value }"
            >
                {{ value ? "Ativo" : "Inativo" }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserRequire2faSection",
    props: {
        value: {
            type: Boolean,
            default: true
        },
        inputId: {
            type: String,
            default: "require_2fa"
        }
    }
};
</script>

<style scoped>
.user-2fa-section {
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    padding: 1rem 1.25rem;
    margin-bottom: 1rem;
}

.user-2fa-section__title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 0.75rem;
    color: #333;
}

.user-2fa-section__control {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.user-2fa-section__status {
    font-size: 0.95rem;
    color: #999;
}

.user-2fa-section__status--active {
    color: #333;
    font-weight: 600;
}
</style>
